var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    { attrs: { dense: "" } },
    _vm._l(
      _vm.stats.filter((e) => !e.hide),
      function (stat, i) {
        return _c(
          "v-col",
          { key: stat.title, attrs: { cols: "6", sm: "3", md: "2", lg: "2" } },
          [
            _c(
              "v-card",
              {
                staticClass: "soli-round",
                staticStyle: { overflow: "hidden" },
                attrs: { ripple: true },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "soli-round",
                    class: _vm.selected == stat.filter ? "selected" : null,
                    staticStyle: { cursor: "pointer" },
                    on: {
                      click: function ($event) {
                        return _vm.selectStat(stat, $event)
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "pa-2 flex-col justify-center align-content-center",
                        class: stat.color,
                        staticStyle: { "min-height": "60px" },
                      },
                      [
                        stat.header
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "white--text flex justify-center subtitle-2",
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(stat.header) +
                                    "\n                    "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "white--text flex justify-center whitespace-no-wrap subtitle-2",
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(stat.title) +
                                "\n                    "
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    (stat.data || stat.data === 0) && !stat.secondaryData
                      ? _c(
                          "v-card-title",
                          {
                            staticClass: "py-3 soli-grey justify-center",
                            staticStyle: { height: "58px" },
                          },
                          [
                            false
                              ? _c("trend", {
                                  staticStyle: {
                                    height: "36px",
                                    position: "absolute",
                                  },
                                  attrs: {
                                    data: stat.trend,
                                    gradient: ["#6fa8dc", "#42b983", "#2c3e50"],
                                    "auto-draw": "",
                                    smooth: "",
                                  },
                                })
                              : _vm._e(),
                            _vm._v(
                              "\n                    " +
                                _vm._s(stat.data) +
                                "\n                "
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    stat.secondaryData || stat.secondaryData === 0
                      ? _c(
                          "v-row",
                          {
                            staticClass: "soli-grey justify-center",
                            staticStyle: { height: "58px" },
                            attrs: { "no-gutters": "" },
                          },
                          [
                            _c(
                              "v-col",
                              {
                                staticClass:
                                  "justify-center flex flex-col px-0 py-2",
                                attrs: { cols: "6" },
                              },
                              [
                                _c("small", { staticClass: "stat-data" }, [
                                  _vm._v(_vm._s(stat.primaryTitle)),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "text-body-1 stat-data" },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(stat.data) +
                                        "\n                        "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _c("v-divider", { attrs: { vertical: "" } }),
                            _c(
                              "v-col",
                              {
                                staticClass:
                                  "justify-center flex flex-col px-0 py-2",
                                attrs: { cols: "6" },
                              },
                              [
                                _c("small", { staticClass: "stat-data" }, [
                                  _vm._v(_vm._s(stat.secondaryTitle)),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "text-body-1 stat-data" },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(stat.secondaryData) +
                                        "\n                        "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !stat.data && stat.data !== 0
                      ? _c("v-skeleton-loader", {
                          staticClass: "mx-auto",
                          attrs: { "max-width": "300", type: "list-item" },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            ),
          ],
          1
        )
      }
    ),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }